import React, {Component} from 'react';
import PropTypes from 'prop-types';
// ---
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import {scrollToNode} from '../../utils';
import PhotoInfo from '../photo-info';

import './styles.css';

/**
 * BC0102HeroImage - 各ページのHeroに直接設定されるか、Hero Carousel Blockに設定されるBlock。
 * - article
 *   - section.HeroImage
 *   - figure `HeroImage__figure__block` - {@link HeroImage.figure}
 *     - {@link HeroImage.imageLink}
 *     - {@link PhotoInfo}
 *   - container `div.HeroImage__container` - {@link HeroImage.container}
 *     - {@link HeroImage.heading}
 *
 * position - `.HeroImage__container`
 * - 【PC】
 *   - Left-Upper：`.left-upper`
 *   - Left-Middle：`.left-middle`
 *   - Left-Lower：`.left-lower`
 *   - Center-Upper：`.center-upper`
 *   - Center-Middle：`.center-middle`
 *   - Center-Lower：`.center-lower`
 *   - Right-Upper：`.right-upper`
 *   - Right-Middle：`.right-middle`
 *   - Right-Lower：`.right-lower`
 * - 【MB】
 *   - Upper：`.upper-mb`
 *   - Middle：`.middle-mb`
 *   - Lower：`.lower-mb`
 *
 * text-align - `.HeroImage__container`
 * - 【PC】
 *   - left：`.align-left-pc`
 *   - center：`.align-center-pc`
 *   - right：`.align-right-pc`
 * - 【MB】
 *   - left：`.align-left-mb`
 *   - center：`.align-center-mb`
 *   - right：`.align-right-mb`
 *
 * 画像サイズ切り替え - `.HeroImage`
 * - 【PC】
 *   - Full：`.fullSize-pc`
 *   - Half：`.halfSize-pc`
 * - 【MB】
 *   - Full：`.fullSize-mb`
 *   - Half：`.halfSize-mb`
 *   - Vertical：`.verticalSize-mb`
 */
export default class HeroImage extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcPreHeading: PropTypes.string,
    mbPreHeading: PropTypes.string,
    preHeadingTag: PropTypes.string,
    pcHeading: PropTypes.string,
    mbHeading: PropTypes.string,
    headingTag: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcPosition: PropTypes.string,
    mbPosition: PropTypes.string,
    pcTextAlign: PropTypes.string,
    mbTextAlign: PropTypes.string,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    pcSize: PropTypes.string,
    mbSize: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
      type: PropTypes.string,
    }),
    imageLink: PropTypes.bool,
    scrollToSlug: PropTypes.bool,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
    // props extends
    photoInfoWillOpen: PropTypes.func,
    photoInfoWillClose: PropTypes.func,
    inHeroCarousel: PropTypes.bool,
    heroCarouselSlideId: PropTypes.string,
    heroCarouselUniqueId: PropTypes.string,
    // ---
    sendMessage: PropTypes.func,
    requestMessageFlag: PropTypes.bool,
  };
  
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcPreHeading: null,
    mbPreHeading: null,
    preHeadingTag: null,
    pcHeading: null,
    mbHeading: null,
    headingTag: null,
    pcDescription: null,
    mbDescription: null,
    pcPosition: null,
    mbPosition: null,
    pcTextAlign: null,
    mbTextAlign: null,
    pcSrc: null,
    mbSrc: null,
    pcSize: null,
    mbSize: null,
    link: null,
    imageLink: null,
    scrollToSlug: null,
    photoInfo: null,
    // props extends
    photoInfoWillOpen: null,
    photoInfoWillClose: null,
    inHeroCarousel: false,
    heroCarouselSlideId: '',
    heroCarouselUniqueId: '',
    // ---
    sendMessage: null,
    requestMessageFlag: false,
  };
  // static getDerivedStateFromProps(props, state) {
  //     // console.log('HeroImage.getDerivedStateFromProps', props, state);
  //     if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
  //         return {
  //             prevHeroCarouselSlideId: state.heroCarouselSlideId,
  //             heroCarouselSlideId: props.heroCarouselSlideId,
  //         };
  //     }
  //     return null;
  // }
  /**
   * heading - tag + text pare を作成します
   * @param {?string} tag heading tag
   * @param {?string} label tag 内 text - `dangerous` option true の時は HTML それ以外は pure text
   * @param {string} defaultClass argument tag value が `Default` 時の代替 tag - HTML で定義されているタグを指定します
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します - 必須です
   * @param {boolean} [dangerous=false] HTML の時に `true` セットします
   * @param {string} [alternate=''] 代替データ - string
   * @param {string} [baseClass=HeroImage__heading] `tag` 引数へ付与する class name 先頭文字
   * @returns {?Element} heading tag を返します
   */
  static headingTag(tag, label, defaultClass, suffix = '', dangerous = false, alternate = '', baseClass = 'HeroImage__heading') {
    const labelText = (label !== null && label) ? label: alternate;
    if (labelText === null || !labelText) {
      return null;
    }
    // make attribute
    const attributes = {
      className: `${baseClass}${(suffix) ? '__': ''}${suffix}`,
    };
    // tag name
    const tagName = (tag) ? tag.toLowerCase(): 'default';
    // create element
    const Element = tagName === 'default' ? defaultClass: tagName;
    // label is plane text
    if (!dangerous) {
      return (
        <Element
          {...attributes}
        >
          {labelText}
        </Element>
      );
    }
    // dangerous - label is HTML
    attributes.dangerouslySetInnerHTML = {__html: convertPipeToBrTag(labelText)};
    return <Element {...attributes} />;
  }
  
  /**
   * description tag text 作成します - {@link convertPipeToBrTag} で `|` to `<br>` 変換を行い insert します
   * @param {?string} description 説明文
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します
   * @param {string} [alternate=''] 代替データ - string
   * @param {string} [baseClass=HeroImage__heading] コンテナへ付与する class name 先頭文字
   * @returns {?Element} description tag を返します
   */
  static descriptionTag(description, suffix = '', alternate = '', baseClass = 'HeroImage__heading') {
    // // require check
    // if (description === null || !description) {
    //     return null;
    // }
    const text = (description !== null && description) ? description: alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    const className = `${baseClass}${(suffix) ? '__': ''}${suffix}`;
    // ReactElement
    return (
      <div className={className + ' Wysiwyg'} dangerouslySetInnerHTML={{__html: text}}/>
    );
  }
  
  /**
   * CTA link tag を作成します - large lint `imageLink` と共存できないので出力時に注意します
   * @param {?{href: string, text: string, type: string, targetBlank: boolean}} link props.link object
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=HeroImage__btn__link] コンテナへ付与する class name 先頭文字
   * @returns {?Element} CTA `a` tag を返します
   */
  static ctaTag(link, suffix = '', baseClass = 'HeroImage__btn__link') {
    // require check
    if (link === null || !link || !link.href || !link.text) {
      return null;
    }
    // a tag
    const type = link.type || '';
    // ---
    return (
      <a
        href={link.href}
        className={`${baseClass}${(suffix) ? '-': ''}${suffix} ${type}`}
        target={(link.targetBlank) ? '_blank': '_self'}
      >
        {link.text}
      </a>
    );
  }
  
  /**
   * `HeroImage` component 初期化作業を行います
   * - {@link HeroImage.onClickInnerLink} bind します
   * @param {*} props React.props
   */
  constructor(props) {
    super(props);
    /**
     * bound onClickInnerLink - button.HeroImage__btn__scroll click event handler
     * @type {bound|any}
     */
    this.onClickInnerLink = this.onClickInnerLink.bind(this);
    /**
     * mobile `Vertical` option - height 必須になるので state 管理します
     * @type {{mbHeight: ?number, entered: string}}
     */
    this.state = {
      mbHeight: null,
      entered: '',
      heroCarouselSlideId: '',
      btnScrollClicked: '',
    };
    this.timer = {
      btnScroll: 0,
      btnEmpty: 0,
      load: 0,
      figure: 0,
    };
    /**
     * mobile `Vertical` option - height 必須になるの load 用ダミー `img` 配置する参照
     * @type {?Element}
     */
    this.mbImg = null;
    // scroll to id
    const {link} = props;
    // href - `#HASH` なリンクがあるかをチェックする
    const href = (link && link.href) ? link.href: null;
    const hash = (href) ? href.split('#').pop(): null;
    /**
     * link.href から HASH 文字取り出す - page 内リンク sweet scroll - {@link scrollToElementId} で使用します
     * @type {?string}
     */
    this.targetId = (hash && hash !== href) ? hash: null;
    /**
     * bound onLinkEnter - imageLink.onmouseenter handler
     * @type {bound|any}
     */
    this.onLinkEnter = this.onLinkEnter.bind(this);
    /**
     * bound onLinkLeave- imageLink.onmouseuleave handler
     * @type {bound|any}
     */
    this.onLinkLeave = this.onLinkLeave.bind(this);
    /**
     * `.hero` element
     * @type {?Element}
     */
    this.heroElement = null;
    this.element = {
      figure: null,
    };
    this.load = {
      pc: false,
      mb: false,
    };
    this.onResize = this.onResize.bind(this);
    this.onPcLoad = this.onPcLoad.bind(this);
    this.onMbLoad = this.onMbLoad.bind(this);
  }
  
  /**
   * button.HeroVideo__btn__scroll click event handler
   * - link.href から hash を取り出します
   * - {@link scrollToNode} で smooth scroll させます
   * - `.hero` 見切れるまで移動します
   * @param {Event} event click event - `preventDefault` します
   */
  onClickInnerLink(event) {
    event.preventDefault();
    // resize 時の移動位置がおかしくなる(scrollToNode bug?)ので毎回新規に取得する
    const heroElement = document.querySelector('.hero');
    if (heroElement) {
      this.heroElement = heroElement;
      const rect = heroElement.getBoundingClientRect();
      // console.log('HeroImage.onClickInnerLink', rect);
      const option = {
        duration: 480,
        offset: rect.height,
      };
      scrollToNode(heroElement, option);
    }
    this.enableButtonScrollEffect();
  }
  
  enableButtonScrollEffect() {
    clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    // clicked flag が ON の時は一度 OFF にし delay し `.HeroImage__btn__scroll__clicked` を付与する
    const delay = this.state.btnScrollClicked ? 16: 0;
    if (delay) {
      this.setState({btnScrollClicked: ''});
    }
    this.timer.btnEmpty = setTimeout(() => {
      this.delayDisposeButtonScrollEffect();
    }, delay);
  }
  
  delayDisposeButtonScrollEffect() {
    this.setState({btnScrollClicked: 'HeroImage__btn__scroll__clicked'});
    this.timer.btnScroll = setTimeout(() => {
      this.setState({btnScrollClicked: ''});
    }, 1750);
  }
  
  /**
   * imageLink enter event handler
   * - `.ImageLink__entered` class 追加
   */
  onLinkEnter() {
    this.setState({entered: 'ImageLink__entered'});
  }
  
  /**
   * imageLink leave event handler
   * - `.ImageLink__entered` class 削除
   */
  onLinkLeave() {
    this.setState({entered: ''});
  }
  
  // -----------------------------------------------------
  onResize() {
    this.getRectFigureBlock();
  }
  
  onPcLoad() {
    this.load.pc = true;
    this.getRectFigureBlock();
  }
  
  onMbLoad() {
    this.load.mb = true;
    this.getRectFigureBlock();
  }
  
  getRectFigureBlock() {
    const {sendMessage, heroCarouselUniqueId} = this.props;
    // console.log('HeroImage.getRectFigureBlock', heroCarouselUniqueId, heroCarouselSlideId);
    if (typeof sendMessage !== 'function') {
      return;
    }
    const {pc, mb} = this.load;
    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    if (!pc || !mb) {
      this.timer.load = setTimeout(() => {
        this.getRectFigureBlock();
      }, 16);
      return;
    }
    const {figure} = this.element;
    if (!figure) {
      this.timer.figure = setTimeout(() => {
        this.getRectFigureBlock();
      }, 16);
      return;
    }
    const rect = figure.getBoundingClientRect();
    sendMessage.call(this, heroCarouselUniqueId, rect);
  }
  
  // -----------------------------------------------------
  componentDidUpdate(prevProps) {
    if (prevProps.requestMessageFlag !== this.props.requestMessageFlag) {
      this.getRectFigureBlock();
    }
  }
  
  componentDidMount() {
    const {inHeroCarousel} = this.props;
    if (inHeroCarousel) {
      window.addEventListener('resize', this.onResize, false);
    }
  }
  
  componentWillUnmount() {
    clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    window.removeEventListener('resize', this.onResize);
  }
  
  // -----------------------------------------------------
  /**
   * props `imageLink` と `link` 値をもとに - Hero全体でリンク設定するか否かのためのコンテナを作成します
   * - HeroImageRoot - `a` or `div`
   * - attributes - HeroImageRoot 属性
   * a 設定時に必要な属性を `attributes` に追加します
   * @returns {?Element} Hero全体でリンク設定するか否かのためのコンテナを返します
   */
  renderImageLink() {
    const {imageLink, link} = this.props;
    // imageLink 設定なし
    if (imageLink === null || !imageLink) {
      return null;
    }
    // link check
    // imageLink の設定有り, link property illegal なので出力しない
    if (link === null || !link.href) {
      return null;
    }
    // type を className へ
    const type = link.type || '';
    return (
      <a
        className={`HeroImage__imageLink ${type}`}
        href={link.href}
        target={(link.targetBlank) ? '_blank': '_self'}
        onMouseEnter={this.onLinkEnter}
        onMouseLeave={this.onLinkLeave}
      />
    );
  }
  
  /**
   * button.HeroImage__btn__scroll Element を作成します
   * - require - link.href HASH
   * - require - scrollToSlug not null
   * - tag have to output - visible control by css class
   * - click -> onClickInnerLink -> {@link scrollToElementId}
   * @returns {?Element} button.HeroImage__btn__scroll
   */
  renderButtonScroll() {
    const {
      scrollToSlug,
      // link,
    } = this.props;
    // const id = this.targetId;
    // require check
    // if (scrollToSlug === null || !id) {
    if (scrollToSlug === null) {
      return null;
    }
    const {btnScrollClicked} = this.state;
    // ---
    // output
    return (
      <button
        className={`HeroImage__btn__scroll ${btnScrollClicked}`}
        type="button"
        onClick={this.onClickInnerLink}
      >
        <i/>
      </button>
    );
  }
  
  // /**
  //  * mobile の背景画像 - onLoad で高さを設定します
  //  * @param {?string|*} src image path
  //  * @returns {{vertical: ?Element, img: ?Element}} mobile figure image
  //  */
  // mbVerticalBg(src) {
  //     if (src === null || !src) {
  //         return {
  //             bg: null,
  //             img: null,
  //         };
  //     }
  //     const vertical = <div className="HeroImage__figure__img HeroImage__figure__img-mb vertical" style={{backgroundImage: `url(${src})`, height: `${this.state.mbHeight}px`}} />;
  //     const img = <img
  //         src={src}
  //         alt=""
  //         style={{display: 'none'}}
  //         ref={component =>(this.mbImg = component)}
  //         onLoad={()=> {
  //             // console.log('img.onLoad', this.mbImg.height);
  //             this.setState({ mbHeight: this.mbImg.height * 0.5 });
  //         }}
  //     />;
  //     // ---
  //     return {
  //         vertical,
  //         img,
  //     };
  // }
  renderFigureImagePc(src) {
    const {inHeroCarousel} = this.props;
    const dummy = inHeroCarousel ? <img
      src={src}
      alt=""
      onLoad={this.onPcLoad}
      style={{display: 'none'}}
    />: null;
    return (
      <div
        className="HeroImage__figure__img HeroImage__figure__img-pc"
        style={{backgroundImage: `url(${src})`}}
      >
        {dummy}
      </div>
    );
  }
  
  renderFigureImageMb(src) {
    const {inHeroCarousel} = this.props;
    // console.log('HeroImage.renderFigureImageMb', inHeroCarousel, src);
    const dummy = inHeroCarousel ? <img
      src={src}
      alt=""
      onLoad={this.onMbLoad}
      style={{display: 'none'}}
    />: null;
    return (
      <div
        className="HeroImage__figure__img HeroImage__figure__img-mb"
        style={{backgroundImage: `url(${src})`}}
      >
        {dummy}
      </div>
    );
  }
  
  /**
   * figure.HeroImage__figure Element 作成します
   * @returns {?Element} figure.HeroImage__figure
   */
  renderFigureImage() {
    const {
      pcSrc,
      mbSrc,
    } = this.props;
    // src exist check
    if (pcSrc === null || !pcSrc) {
      return null;
    }
    // pc - default
    const mobileSrc = mbSrc || pcSrc;
    // const pcImg = <div
    //     className="HeroImage__figure__img HeroImage__figure__img-pc"
    //     style={{backgroundImage: `url(${pcSrc})`}}
    // />;
    // const mbImg = <div
    //     className="HeroImage__figure__img HeroImage__figure__img-mb"
    //     style={{backgroundImage: `url(${mobileSrc})`}}
    // />;
    const pcImg = this.renderFigureImagePc(pcSrc);
    const mbImg = this.renderFigureImageMb(mobileSrc);
    return (
      <div className="HeroImage__figure">
        {pcImg}
        {mbImg}
      </div>
    );
  }
  
  /**
   * {@link PhotoInfo} props 拡張します
   * @returns {?Array<ReactElement>}
   */
  renderPhotoInfoContainer() {
    const {
      photoInfo,
      containerId,
      photoInfoWillOpen,
      photoInfoWillClose,
      inHeroCarousel,
      heroCarouselSlideId,
    } = this.props;
    // photoInfo - arrayOf だけど出力は1件
    const photoInfoList = (photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length) ? photoInfo: [];
    // PhotoInfo.props extends
    return photoInfoList.map((child, index) => {
      // console.log('HeroImage.photoInfoContainer.map', child, child.type.displayName);
      return (child.type.displayName === 'PhotoInfo') ?
        <PhotoInfo
          key={`PhotoInfo-${child.props.containerId}-${index}`}
          {...child.props}
          parentComponentName="HeroImage"
          parentComponentId={containerId}
          photoInfoWillOpen={photoInfoWillOpen}
          photoInfoWillClose={photoInfoWillClose}
          inHeroCarousel={inHeroCarousel}
          heroCarouselSlideId={heroCarouselSlideId}
        />: null;
    });
  }
  
  /**
   * `pcSrc` / `spSrc` から figure tag を作成します
   * - {@link HeroImage.figureImage}
   * - {@link HeroImage.imageLink}
   * - {@link PhotoInfo}
   * @returns {?Element}
   */
  renderFigure() {
    // src exit check
    const figure = this.renderFigureImage();
    // large link
    const imageLink = this.renderImageLink();
    // PhotoInfo
    const photoInfoList = this.renderPhotoInfoContainer();
    // button scroll
    const buttonScroll = this.renderButtonScroll();
    // console.log('HeroImage.figure - photoInfoList', photoInfoList);
    // output check
    if (!figure && !imageLink && !photoInfoList.length && !buttonScroll) {
      return null;
    }
    // output
    return (
      <div
        className="HeroImage__figure__block"
        ref={component => (this.element.figure = component)}
      >
        {figure}
        {imageLink}
        {photoInfoList}
        {buttonScroll}
      </div>
    );
  }
  
  /**
   * `div.HeroImage__heading` section 作成します
   * - preHeading
   * - heading
   * - description
   * @returns {?Element} `div.HeroImage__heading` を返します
   */
  renderHeading() {
    const {
      pcPreHeading,
      mbPreHeading,
      preHeadingTag,
      pcHeading,
      mbHeading,
      headingTag,
      pcDescription,
      mbDescription,
    } = this.props;
    // ---
    const alternate = {
      heading: pcHeading,
      pre: pcPreHeading,
      description: pcDescription,
    };
    // ---
    const tags = {
      pcPre: HeroImage.headingTag(preHeadingTag, pcPreHeading, 'h3', 'pcPreHeading', true),
      pcHead: HeroImage.headingTag(headingTag, pcHeading, 'h2', 'pcHeading', true),
      mbPre: HeroImage.headingTag(preHeadingTag, mbPreHeading, 'h3', 'mbPreHeading', true, alternate.pre),
      mbHead: HeroImage.headingTag(headingTag, mbHeading, 'h2', 'mbHeading', true, alternate.heading),
      pcDescription: HeroImage.descriptionTag(pcDescription, 'pcDescription'),
      mbDescription: HeroImage.descriptionTag(mbDescription, 'mbDescription', alternate.description),
    };
    // null 以外を check
    const hasTag = Object.values(tags).some(tag => (tag !== null));
    if (!hasTag) {
      // 全て null なので処理しない
      return null;
    }
    // tag exist
    return (
      <div className="HeroImage__heading">
        {tags.pcPre}
        {tags.mbPre}
        {tags.pcHead}
        {tags.mbHead}
        {tags.pcDescription}
        {tags.mbDescription}
      </div>
    );
  }
  
  /**
   * `div.HeroImage__container` section 作成します
   * - pcPosition / mbPosition から css class 作成し設定します
   * - pcTextAlign / mbTextAlign から css class 作成し設定します
   * - {@link HeroImage.heading}
   * - {@link HeroImage.buttonScroll}
   * - mb - CTA
   * @returns {?Element} `div.HeroImage__container` を返します
   */
  renderContainer() {
    const {
      pcPosition,
      mbPosition,
      // imageLink,
      pcTextAlign,
      mbTextAlign,
      link,
    } = this.props;
    // ---
    const heading = this.renderHeading();
    // buttons
    // // scroll
    // const buttonScroll = this.buttonScroll();
    // cta mb - large link ある時は cta 無い
    // const cta = (imageLink === null || !imageLink) ? HeroImage.ctaTag(link) : null;
    const cta = HeroImage.ctaTag(link);
    // output
    if (!heading && !cta) {
      return null;
    }
    // positions
    const positions = {
      pc: (pcPosition !== null && pcPosition) ? pcPosition.toLowerCase(): '',
      mb: (mbPosition !== null && mbPosition) ? `${mbPosition.toLowerCase()}-mb`: '',
    };
    const ctaClassName = (cta) ? 'has-btn__link': '';
    // align
    const alignPc = (pcTextAlign !== null && pcTextAlign) ? `align-${pcTextAlign.toLowerCase()}-pc`: '';
    const alignMb = (mbTextAlign !== null && mbTextAlign) ? `align-${mbTextAlign.toLowerCase()}-mb`: '';
    // tag exist
    return (
      <div
        className={`HeroImage__container ${positions.pc} ${positions.mb} ${ctaClassName} ${alignPc} ${alignMb}`}
      >
        {heading}
        {cta}
      </div>
    );
  }
  
  /**
   * `HeroImage` Element - props `null` check 後に render します
   * - {@link HeroImage.figure}
   * - {@link HeroImage.container}
   * @returns {?Element} `HeroImage`
   */
  render() {
    const {
      containerId,
      containerClass,
      pcSize,
      mbSize,
      scrollToSlug,
    } = this.props;
    // ---
    const figure = this.renderFigure();
    const container = this.renderContainer();
    // 出力対象存在チェック
    if (!figure && !container) {
      return null;
    }
    // ---
    // size setting
    const sizePc = (pcSize !== null && pcSize) ? `${pcSize.toLowerCase()}Size-pc`: '';
    const sizeMb = (mbSize !== null && mbSize) ? `${mbSize.toLowerCase()}Size-mb`: '';
    // ---
    // visible class
    const visible = !!scrollToSlug ? 'is-show-scroll_btn': 'is-hide-scroll_btn';
    // ---
    const {entered} = this.state;
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <article className="HeroImage__article">
          <section
            className={`HeroImage ${sizePc} ${sizeMb} ${visible} ${entered}`}
          >
            {
              /* figure */
              figure
            }
            {
              /* container */
              container
            }
          </section>
        </article>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/hero-image/index.jsx